if (!customElements.get("oddit-pagination")) {
  class OdditPagination extends HTMLElement {
    constructor() {
      super();
      this.PAGE_PARAM = "page"
      this.BASE_URL = window.location.pathname
      this.WRAPPER_SELECTOR = '.td--collection__wrapper'
      this.ITEM_SELECTOR = '.td--collection__item'
      this.TEXT_SELECTOR = '.td--odd_page__text'
      this.LOADER_SELECTOR = '.td--odd-page__loader-wrapper'
      this.RESULT_IMAGE_SELECTOR =  '.odd_image-wrapper img'

      this.LOADER_HIDDEN_CLASS = 'td--odd-page__loader--inactive'
      this.TEXT_HIDDEN_CLASS = 'td--odd-page__text--inactive'
      this.ITEM_LOAD_IN_CLASS = 'td--item--load_in'

      this.ANIMATION_DELAY = 100
      this.ITEMS_TO_EAGER_LOAD = 2

      this.wrapper = document.querySelector(this.WRAPPER_SELECTOR)
      this.loader = document.querySelector(this.LOADER_SELECTOR)
      this.textWrapper = document.querySelector(this.TEXT_SELECTOR)

      this.isLoading = false;
      this.page = 2;
      this.pageSize = this.dataset.pageSize
    }
    connectedCallback() {
      setTimeout(() => {
        this.attachListeners();
      });
    }
    attachListeners() {
      this.addEventListener('click', this.handleMoadMore.bind(this))
    }
    handleMoadMore() { 
      if (!this.isLoading) {
        this.isLoading = true;
        const queryParams = new URLSearchParams(window.location.search);

        queryParams.set(this.PAGE_PARAM, this.page);
        const requestUrl = [this.BASE_URL, "?", queryParams.toString()].join("")
        if(!this.wrapper) return

        
          // this.textWrapper.addEventListener('transitionend', () => {
          //   this.textWrapper.style.display = 'none'
          //   this.loader.style.display = null
          //   this.loader.classList.remove(this.LOADER_HIDDEN_CLASS)
          // }, {
          //   once: true
          // })
          // this.textWrapper.classList.add(this.TEXT_HIDDEN_CLASS)
        const delay = 1;
        
        this.textWrapper.classList.add(this.TEXT_HIDDEN_CLASS)
        this.loader.style.display = null
        setTimeout(() => {
          this.loader.classList.remove(this.LOADER_HIDDEN_CLASS)
        }, delay * 100);
        
        fetch(requestUrl)
          .then(function (response) {
            return response.text();
          })
          .then((html) => {
            try {
              var parser = new DOMParser();
              var doc = parser.parseFromString(html, "text/html");
              const additionalResults = doc.querySelectorAll(this.ITEM_SELECTOR);
              if (additionalResults.length) {
                additionalResults.forEach((result, index) => {
                  result.classList.add(this.ITEM_LOAD_IN_CLASS)
                  if (index < this.ITEMS_TO_EAGER_LOAD) {
                    const mainImage = result.querySelector(this.RESULT_IMAGE_SELECTOR)
                    if (mainImage) {
                      mainImage.setAttribute('loading', 'eager')
                    }
                  }
                  this.wrapper.appendChild(result)
                  setTimeout(() => {
                    result.classList.remove(this.ITEM_LOAD_IN_CLASS)
                  }, this.ANIMATION_DELAY * (index + 1))
                })
                this.page += 1;
                if (this.pageSize > additionalResults.length) {
                  this.remove()
                }
              }
            } catch (err) {
              // There was an error
              console.error("Something went wrong.", err);
            }
          })
          .catch(function (err) {
            // There was an error
            console.error("Something went wrong.", err);
          })
          .finally(() => {
            this.isLoading = false;
            if (this.loader && this.textWrapper) {
              setTimeout(() => {
                this.loader.classList.add(this.LOADER_HIDDEN_CLASS)
                this.textWrapper.style.display = null
                this.textWrapper.classList.remove(this.TEXT_HIDDEN_CLASS)                
              }, delay * 1000);
            }
            const paginationComplete = new Event("oddit-pagination-complete");
            document.dispatchEvent(paginationComplete);
          });
      }
    }
  }
  customElements.define("oddit-pagination", OdditPagination);
  
}
